import PropTypes from 'prop-types';
import React from 'react';
import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { DL_SERVICE_URL } from '../../config';
import { placeTypeName, simplePlaceName, plural, impactSort, sameLocationNewHash, downloadImage } from '../../utils/utils';
import { SetImpactGroup, SetImpact, SetImpactName, SetImpactSubgroup,
         SetProtection, SetImpactPct, SetModalVisible, SetComparisonType } from '../../actions';
import * as d3 from 'd3';
import ImpactSettings from '../ImpactSettings';
import ImpactTable from '../ImpactTable';
import Modal from '../Modal';
import ComponentIcons from '../ComponentIcons';
import Comparison from '../Comparison';
import ComparisonSelector from '../ComparisonSelector';
import DownloadForm from '../DownloadForm';
import PlaceRanking from '../PlaceRanking';
import SourcesCaption from '../SourcesCaption';
import ToggleText from '../ToggleText';
import styles from './Impacts.css';
import withStyles from '../../decorators/withStyles';
import { abbrevLower } from "../../utils/utils";
import AnchoredComponent from "../AnchoredComponent";
import {SetModalTitle} from "../../actions";
import { downloadFile, gaEvent, isUS, xlt } from "../../utils/utils";
import { pngIcon, xlsIcon } from "../../icons";


class Impacts extends AnchoredComponent {

  static propTypes = {
    placeType: PropTypes.string.isRequired,
    placeID: PropTypes.string.isRequired,
    protection: PropTypes.string.isRequired,
    waterLevel: PropTypes.object.isRequired,

    impact: PropTypes.string.isRequired,

    impactMeta: PropTypes.object.isRequired,
    boundaryMeta: PropTypes.object.isRequired,
    elevMeta: PropTypes.object.isRequired,
  };

  static defaultProps = {
    summarySize: 5,
    impactGroupOrder: ['Population', 'Buildings', 'Infrastructure', 'Contamination Risks', 'Land'],
    hasTable: true,
    hasChoropleth: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      data: {},
      dlType: "impact-summary",
      downloadOpen: false,
      settingsOpen: false,
      sourcesOpen: false,
      refs: []
    };
  }

  componentDidUpdate() {
    this.state.refs.forEach(ref => {
      // Transifex.live.translateNode(ref);
    })
  }

  setTxContent = el => {
    // this.state.refs.push(el);
    d3.select(el).attr("tx-content", "block");
  };

  openInfo = e => {
    gaEvent('modal', 'open', 'info-impacts');
    browserHistory.push({pathname: "/about", hash: "#about-risks-what",
      state: {modal: true, modalTitle: "About this site", returnTo: location.pathname}});
  };

  openSettings = e => {
    this.closeAll();
    gaEvent('modal', 'open', 'settings-impacts');
    this.props.dispatch(SetModalVisible(true));
    this.setState({settingsOpen: true});
  };

  closeSettings = e => {
    this.props.dispatch(SetModalVisible(false));
    this.setState({settingsOpen: false});
  };

  openDownload = e => {
    this.closeAll();
    // gaEvent('modal', 'open', 'download-impacts');
    this.props.dispatch(SetModalVisible(true));
    this.setState({downloadOpen: true});
  };

  closeDownload = e => {
    this.props.dispatch(SetModalVisible(false));
    this.setState({downloadOpen: false});
  };

  openSources = e => {
    e.preventDefault();
    this.closeAll();
    this.props.dispatch(SetModalVisible(true));
    this.setState({sourcesOpen: true});
  };

  closeSources = e => {
    this.props.dispatch(SetModalVisible(false));
    this.setState({sourcesOpen: false});
  };

  closeAll = () => {
    this.props.dispatch(SetModalVisible(false));
    this.setState({sourcesOpen: false, downloadOpen: false, settingsOpen: false});
  };

  handleImpactGroupClick(name, facts) {
    gaEvent('configure', 'impact-group', name);
    var sortF = impactSort.bind(this, this.props.waterLevel, this.props.impactPct);
    facts[name].sort(sortF);
    //this.props.dispatch(SetImpactSubgroupExclusions({}));
    this.props.dispatch(SetImpactSubgroup("All"));
    this.props.dispatch(SetImpactGroup(name));
    if (facts[name] && facts[name].length > 0) {
      this.props.dispatch(SetImpact(facts[name][0].key));
      this.props.dispatch(SetImpactName(facts[name][0].name));
    }
  }

  handleImpactPctChange = e => {
    this.props.dispatch(SetImpactPct(!this.props.impactPct));
  };

  handleProtectionChange = e => {
    this.props.dispatch(SetProtection(e.target.value === "true" ? "protected" : "unprotected"));
  };

  toggleProtection = (e) => {
    e.preventDefault();
    if (this.props.protection === "protected") {
      this.props.dispatch(SetProtection("unprotected"));
    } else {
      this.props.dispatch(SetProtection("protected"));
    }
  };

  handleComparisonChange = value => {
    gaEvent('configure', 'click', 'comparison-change');
    this.props.dispatch(SetComparisonType(value));
  };

  navigateTo = path => {
    window.scrollTo(0, 0);
    browserHistory.push({pathname: `/${path}`});
  };

  setDlType(dlType) {
    if (dlType.indexOf("-pptx") !== -1) {
      this.props.dispatch(SetModalTitle("Get slide"));
    } else if (dlType.indexOf("-img") !== -1) {
      this.props.dispatch(SetModalTitle("Get image"));
    } else {
      this.props.dispatch(SetModalTitle("Get spreadsheet"));
    }
    this.setState({dlType: dlType});
  }

  ssTarget(dlType) {
    const { placeType, placeID, waterLevel, impactPct, comparisonType, impact, impactGroup } = this.props;
    const baseURL = "http://riskfinder.climatecentral.org/embed";
    const pctParam = impactPct ? "&impactPct=true" : "";
    const lang = Transifex.live.getSelectedLanguageCode();
    return `${baseURL}/${dlType}/${placeType}/${placeID}?level=${waterLevel.level}&unit=${waterLevel.unit}&impact=${impact}&impactGroup=${impactGroup}&comparisonType=${comparisonType}&lang=${lang}${pctParam}`;
  }

  dlCallback = (onDlComplete) => {
    const { placeType, placeID, impact, comparisonType } = this.props;
    if (this.state.dlType === "impact-comparison-img" || this.state.dlType === "impact-table-img") {
      const filename = `surging-seas-comparison-${placeID}.png`;
      const url = DL_SERVICE_URL + "/screenshot" + `?filename=${filename}&width=1024&height=768&url=` +
        encodeURIComponent(this.ssTarget(this.state.dlType));
      downloadImage(url, this.state.dlType + ".png", onDlComplete);
    } else if (this.state.dlType === "impact-comparison-pptx") {
      const filename = `surging-seas-comparison-${placeID}.pptx`;
      const url = DL_SERVICE_URL + "/screenshot" + `?format=pptx&filename=${filename}&width=1024&height=768&url=` +
          encodeURIComponent(this.ssTarget("impact-comparison-img"));
        downloadFile(url, "riskfinder-comparison.pptx", onDlComplete);
    } else {
      // Add artificial delay so that people will look at our pre-download advertisements.
      setTimeout(() => {
        const link = document.createElement('a');
        if (this.state.dlType === "impact-summary") {
          link.href = `/api/impacts/${placeType}/${placeID}?tableType=${this.state.dlType}`;
          link.download = `impact-summary-${placeID}.xls`;
        } else if (this.state.dlType === "impact-detail") {
          link.href = `/api/impacts/${placeType}/${placeID}?tableType=${this.state.dlType}&impact=${impact}`;
          link.download = `impact-detail-${impact}-${placeID}.xls`;
        } else if (this.state.dlType === "impact-list") {
          link.href = `/api/impacts/${placeType}/${placeID}?tableType=${this.state.dlType}&impact=${impact}`;
          link.download = `impact-list-${impact}-${placeID}.xls`;
        } else if (this.state.dlType === "impact-comparison") {
          link.href = `/api/impacts/${placeType}/${placeID}?tableType=${this.state.dlType}&comparisonType=${comparisonType}&impact=${impact}`;
          link.download = `impact-comparison-${impact}-${placeID}.xls`;
        } else {
          return onDlComplete({error: "Download not available."});
        }
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        //link.parentNode.removeChild(link);
        if (onDlComplete) {
          onDlComplete(null, link.href);
        }
      }, 5 * 1000);
    }
  };

  handleDownloadClick = dlType => {
    gaEvent('modal', 'open', `download-${dlType}`);
    this.setDlType(dlType);
    this.openDownload();
  };

  impactHasNameList(impact) {
    const impactsWithoutLists = [
      'Housing', 'Land', 'Population', 'Property', 'Protected', 'Rail', 'Roads',
    ];
    for (let impactType of impactsWithoutLists) {
      if (impact.includes(impactType)) {
        return false;
      }
    }
    return true;
  }

  render() {
    const { isEmbed, modalVisible } = this.props;
    const { data, noData, factCriteria, impactMeta, boundaryMeta, impactsByGroup,
            placeName, placeType, placeID, placeContainer, waterLevel, protection, impact, impactName, placeRanking,
            impactGroup, impactGroupOrder, impactPct, impactSubgroupExclusions, comparisonType, availableComparisons } = this.props;

    const contiglevees = protection === "protected" ? "tidelcontiglevees" : "tidelthresh";

    const header = (
        <div>
          <div className="header">
            <a className="anchor" id="impacts-in-depth"/>
            <Link className="hash-link" to={sameLocationNewHash("#impacts-in-depth")}>
              <h1>What Is at Risk? <span className="anchor-hash">#</span></h1>
            </Link>
            <ComponentIcons tutorialUrl="https://www.youtube.com/watch?v=s1w7UMzt9Gs" hasDownload={false} openSettings={this.openSettings}
                            openDownload={() => {this.setDlType("impact-comparison-pptx"); this.openDownload()}} openInfo={this.openInfo}
            />
          </div>

          {!placeID.endsWith(".us") ? null :
              <div className="tab-group">
                {impactGroupOrder.filter(k => impactsByGroup[k].length > 0).map(k => {
                      return <h3 key={k}
                                 className={"impactTab" + (impactGroup === k ? " active" : "")}
                                 onClick={this.handleImpactGroupClick.bind(this, k, impactsByGroup)}>{k}
                      </h3>
                    }
                )}
              </div>
          }

        </div>
    );

    var tableImpacts = {Population: []};
    if (!isUS(placeID)) {
      for (var k in impactsByGroup) {
        if (impactsByGroup.hasOwnProperty(k)) {
          impactsByGroup[k].forEach(item => {
            tableImpacts["Population"].push(item)
          });
        }
      }
      tableImpacts["Population"].sort((a, b) => a.name < b.name ? -1 : 1);
    } else {
      tableImpacts = impactsByGroup;
    }

    const table = (
        <div >
          <ImpactTable
            isEmbed={false}
            placeID={placeID}
            placeName={placeName}
            waterLevel={waterLevel}
            impact={impact}
            impactGroup={impactGroup}
            impactPct={impactPct}
            impacts={tableImpacts}
            protection={protection}
            factCriteria={factCriteria}
            handleImpactPctChange={this.handleImpactPctChange}
            toggleProtection={this.toggleProtection}
            subcategoryExclusions={impactSubgroupExclusions}
            noData={noData}
            openSources={this.openSources}
            impactMeta={impactMeta}
            boundaryMeta={boundaryMeta}
            elevMeta={this.props.elevMeta}
            impactName={impactName}
            handleDownloadClick={this.handleDownloadClick}
          />
        </div>
    );

    const totalToggle = (<ToggleText>
      <span onClick={this.handleImpactPctChange}>
        {impactPct ? xlt('Percentage of') : xlt('Total')}
      </span>
    </ToggleText>);

    const setTxContent = (el) => d3.select(el).attr('tx-content', 'block');

    const choropleth = (
        <div className="ImpactChoropleth">
            <p className="supertitle small-text">Choose a threat to map using the scrollable list above</p>
            <h2 style={{width: "90%"}}><a className="anchor" id="exposure-comparison"/>
              <var>{totalToggle} </var>
              <var>{abbrevLower(xlt(impactName))} </var>
              <span>below</span>
              <var> {waterLevel.level} {waterLevel.unit} </var>
            <ComparisonSelector
              placeName={placeName}
              placeType={placeType}
              comparisonType={comparisonType}
              comparisonParent={this.props.comparisonParent}
              placeSSID={this.props.ssid}
              placeContainer={placeContainer}
              handleComparisonChange={this.handleComparisonChange}
              subRegions={availableComparisons}
              population={this.props.population}
              isEmbed={isEmbed}
            />
              <svg className="download-icon" version="1.1" viewBox="0 0 585.918 585.918" onClick={this.handleDownloadClick.bind(null, "impact-comparison-img")}>
                {pngIcon}
              </svg>
              {isUS(placeID) ?
                <svg className="download-icon" version="1.1" viewBox="0 0 585.918 585.918" onClick={this.handleDownloadClick.bind(null, "impact-comparison")}>
                  {xlsIcon}
                </svg>
                : null}
            </h2>

          <Comparison
            impact={impact}
            percentage={impactPct}
            placeType={placeType}
            placeID={placeID}
            placeContainer={placeContainer}
            placeName={placeName}
            waterLevel={waterLevel}
            protection={contiglevees}
            noData={noData}
            comparisonType={comparisonType}
            impactName={(impact in factCriteria && factCriteria[impact].name) ? factCriteria[impact].name : impactName}
            impactPosttransform={impact in factCriteria && factCriteria[impact].posttransform}
            impactPretransform={impact in factCriteria && factCriteria[impact].pretransform}
          />
          <PlaceRanking
            placeList={placeRanking}
            impactName={impact}
            impactPct={impactPct}
            impactPosttransform={impact in factCriteria && factCriteria[impact].posttransform}
            impactPretransform={impact in factCriteria && factCriteria[impact].pretransform}
            handleClick={this.navigateTo}
          />
          <SourcesCaption
            impactMeta={impactMeta}
            boundaryMeta={boundaryMeta}
            elevMeta={this.props.elevMeta}
            impactName={impactName}
            openSources={this.openSources}
          />
          {isUS(placeID) ?
          <p ref={this.setTxContent} key={Math.random()}>Values&nbsp;
            <ToggleText>
              <span onClick={this.toggleProtection}>{(this.props.protection === "protected" ? "exclude" : "include")}</span>
            </ToggleText> sub-<var>{waterLevel.level}</var><var>{waterLevel.unit}</var> areas potentially protected by levees or other features.&nbsp;
            <Link to={{pathname: "/about", hash: "#about-levees", state: {modal: true, modalTitle: "About this site",
                                                                        returnTo: location.pathname}}}>
              <span className="icon question-mark" />
            </Link>
          </p>
              : null}
        </div>
    );

    return (
      <div className="Impacts">
        {header}
        <div className="impactSection">
          {table}
          {(!placeID.endsWith(".pa") && !placeID.endsWith(".ni")) ? choropleth : null}
        </div>

        <Modal isOpen={this.state.sourcesOpen && modalVisible}
               handleClick={this.closeSources} title="Notes on Methods">
          {impactMeta.method ?
            <div>
              <h3>{`${impactName} analysis method`}</h3>
              <p>{impactMeta.method}</p>
              {isUS(placeID) ?
                  <p>Depending on user selection, analysis may exclude areas that levees or other features appear to protect.</p>
                  : null}
            </div>
            : null}
          <div>
            <h3>Elevation data accuracy</h3>
            {this.props.elevMeta.name === "lidar" ?
              <p>Lidar elevation data have high vertical accuracy and support robust exposure analysis.</p> :
                this.props.elevMeta.name === 'NASA SRTM v3' ?
                    <p></p> :
                    <p ref={this.setTxContent}>Climate Central's <a href="http://sealevel.climatecentral.org/uploads/research/CoastalDEMv1.1-Brief.pdf" target="_blank">CoastalDEM</a> is
                    a near-global coastal elevation dataset with
                    vertical accuracy that strongly outperforms NASA's widely used SRTM data, and that approaches
                    lidar-based data.
                    </p>
            }
          </div>
        </Modal>

        <Modal isOpen={this.state.settingsOpen && this.props.modalVisible} handleClick={this.closeSettings}
               title="Impact settings">
          <ImpactSettings
            handleImpactPctChange={this.handleImpactPctChange}
            handleProtectionChange={this.handleProtectionChange}
            showProtection={isUS(placeID)}
            protection={protection}
            impactPct={impactPct}
          />
        </Modal>

        <Modal isOpen={this.state.downloadOpen && this.props.modalVisible}
               handleClick={this.closeDownload}
        >
          <DownloadForm
            id="ImpactDLForm"
            placeType={placeType}
            placeID={placeID}
            dlType={this.state.dlType}
            productID="impacts"
            dlCallback={this.dlCallback}
          >
            <p className="detail">Downloads detail {impactName.toLowerCase()} on low-lying land in {simplePlaceName(placeName)} with&nbsp;
              {placeTypeName(comparisonType, placeType).toLowerCase()} breakdowns,
              unless otherwise noted. To change focal water level, impact, area type breakdown, or location,
              close this dialog box and change your selection(s).
            </p>
            {(this.state.dlType === "impact-summary" || this.state.dlType === "impact-comparison" || this.state.dlType === "impact-detail" || this.state.dlType === "impact-list") ?
            <div>
              <h4>Data spreadsheets for water levels 1-10 ft (format: xls)</h4>
              <div className="dl-options">
                <label>
                  <input type="radio" name="dl-type" value="impact-summary"
                         onClick={this.setDlType.bind(this, "impact-summary")}
                         checked={this.state.dlType === "impact-summary"}
                  /> All available categories in {simplePlaceName(placeName)}: Summary*
                </label>
                <label>
                  <input type="radio" name="dl-type" value="impact-comparison"
                         onClick={this.setDlType.bind(this, "impact-comparison")}
                         checked={this.state.dlType === "impact-comparison"}
                  /> {impactName} in {simplePlaceName(placeName)}: Comparison
                  by {placeType === "place" ? "town" : placeTypeName(comparisonType).toLowerCase()}*
                </label>
                <label>
                  <input type="radio" name="dl-type" value="impact-detail"
                         onClick={this.setDlType.bind(this, "impact-detail")}
                         checked={this.state.dlType === "impact-detail"}
                  /> {impactName} in {simplePlaceName(placeName)}: Breakdown by protection status and social
                  vulnerability levels
                </label>
                {this.impactHasNameList(impact) ?
                  <label>
                    <input type="radio" name="dl-type" value="impact-list"
                           onClick={this.setDlType.bind(this, "impact-list")}
                           checked={this.state.dlType === "impact-list"}
                    /> {impactName} in {simplePlaceName(placeName)}: Individual facilities list*
                  </label>
                  : null}
              </div>
              <p>*Potential protections from levees or other features not factored in</p>
            </div>
            : null}
            <br />
          </DownloadForm>
        </Modal>
      </div>
    );

  };
}

// Use connect solely for access to redux "dispatch";
// Don't use any state from the store. Such props will be passed directly.
export default compose(
  withStyles(styles),
  connect(() => {return {};}),
)(Impacts);
